{
  "username": "Ім'я користувача",
  "password": "Пароль",
  "login": "Увійти",
  "confirm": "Підтвердити",
  "cancel": "Скасувати",
  "close": "Закрити",
  "save": "Зберегти",
  "logout": "Вийти",
  "create": "Створити",
  "add": "Додати",
  "remove": "Видалити",
  "update": "Оновити",
  "copy": "Копіювати",
  "copied": "Скопійовано",
  "more": "більше",
  "download": "Завантажити",
  "remark": "Примітка",
  "enable": "Увімкнути",
  "protocol": "Протокол",
  "search": "Пошук",
  "filter": "Фільтр",
  "all": "Усі",
  "from": "Від",
  "to": "До",
  "done": "Готово",
  "loading": "Завантаження...",
  "refresh": "Оновити",
  "clear": "Очистити",
  "second": "Секунда",
  "minute": "Хвилина",
  "hour": "Година",
  "day": "День",
  "check": "Перевірка",
  "indefinite": "Безстроково",
  "unlimited": "Безлімітний",
  "none": "Немає",
  "qrCode": "QR-Код",
  "info": "Більше інформації",
  "edit": "Змінити",
  "delete": "Видалити",
  "reset": "Скидання",
  "noData": "Немає даних.",
  "copySuccess": "Скопійовано успішно",
  "sure": "Звичайно",
  "encryption": "Шифрування",
  "useIPv4ForHost": "Використовувати IPv4 для хоста",
  "transmission": "Протокол передачи",
  "host": "Хост",
  "path": "Шлях",
  "camouflage": "Обфускація",
  "status": "Статус",
  "enabled": "Увімкнено",
  "disabled": "Вимкнено",
  "depleted": "Вичерпано",
  "depletingSoon": "Вичерпується",
  "offline": "Не в мережі",
  "online": "У мережі",
  "domainName": "Доменне ім`я",
  "monitor": "Слухати IP",
  "certificate": "Цифровий сертифікат",
  "fail": "Помилка",
  "comment": "Коментар",
  "success": "Успішно",
  "lastOnline": "Був(ла) онлайн",
  "getVersion": "Отримати версію",
  "install": "Встановити",
  "clients": "Клієнти",
  "usage": "Використання",
  "twoFactorCode": "Код",
  "remained": "Залишилося",
  "security": "Беспека",
  "secAlertTitle": "Попередження системи безпеки",
  "secAlertSsl": "Це з'єднання не є безпечним. Будь ласка, уникайте введення конфіденційної інформації, поки TLS не буде активовано для захисту даних.",
  "secAlertConf": "Деякі налаштування вразливі до атак. Рекомендується посилити протоколи безпеки, щоб запобігти можливим порушенням.",
  "secAlertSSL": "Панель не має безпечного з'єднання. Будь ласка, встановіть сертифікат TLS для захисту даних.",
  "secAlertPanelPort": "Стандартний порт панелі вразливий. Будь ласка, сконфігуруйте випадковий або конкретний порт.",
  "secAlertPanelURI": "Стандартний URI-шлях панелі небезпечний. Будь ласка, сконфігуруйте складний URI-шлях.",
  "secAlertSubURI": "Стандартний URI-шлях підписки небезпечний. Будь ласка, сконфігуруйте складний URI-шлях.",
  "secAlertSubJsonURI": "Стандартний URI-шлях JSON підписки небезпечний. Будь ласка, сконфігуруйте складний URI-шлях.",
  "emptyDnsDesc": "Немає доданих DNS-серверів.",
  "emptyFakeDnsDesc": "Немає доданих Fake DNS-серверів.",
  "emptyBalancersDesc": "Немає доданих балансувальників.",
  "emptyReverseDesc": "Немає доданих зворотних проксі.",
  "somethingWentWrong": "Щось пішло не так",
  "subscription": {
    "title": "Інформація про підписку",
    "subId": "ID підписки",
    "status": "Статус",
    "downloaded": "Завантажено",
    "uploaded": "Відвантажено",
    "expiry": "Термін дії",
    "totalQuota": "Загальна квота",
    "individualLinks": "Окремі посилання",
    "active": "Активна",
    "inactive": "Неактивна",
    "unlimited": "Безліміт",
    "noExpiry": "Без строку"
  },
  "menu": {
    "theme": "Тема",
    "dark": "Темна",
    "ultraDark": "Ультра темна",
    "dashboard": "Огляд",
    "inbounds": "Вхідні",
    "clients": "Клієнти",
    "groups": "Групи",
    "nodes": "Вузли",
    "settings": "Налаштування панелі",
    "xray": "Конфігурації Xray",
    "apiDocs": "Документація API",
    "logout": "Вийти",
    "link": "Керувати",
    "donate": "Підтримати"
  },
  "pages": {
    "login": {
      "hello": "Привіт",
      "title": "Привітання!",
      "loginAgain": "Ваш сеанс закінчився, увійдіть знову",
      "toasts": {
        "invalidFormData": "Формат вхідних даних недійсний.",
        "emptyUsername": "Потрібне ім'я користувача",
        "emptyPassword": "Потрібен пароль",
        "wrongUsernameOrPassword": "Невірне ім’я користувача, пароль або код двофакторної аутентифікації.",
        "successLogin": "Ви успішно увійшли до свого облікового запису."
      }
    },
    "index": {
      "title": "Огляд",
      "cpu": "CPU",
      "logicalProcessors": "Логічні процесори",
      "frequency": "Частота",
      "swap": "Swap",
      "storage": "Сховище",
      "memory": "RAM",
      "threads": "Потоки",
      "xrayStatus": "Xray",
      "stopXray": "Стоп",
      "restartXray": "Перезапуск",
      "xraySwitch": "Версія",
      "xrayUpdates": "Оновлення Xray",
      "xraySwitchClick": "Виберіть версію, на яку ви хочете перейти.",
      "xraySwitchClickDesk": "Вибирайте уважно, оскільки старіші версії можуть бути несумісними з поточними конфігураціями.",
      "updatePanel": "Оновити панель",
      "panelUpdateDesc": "Це оновить 3X-UI до останнього релізу та перезапустить сервіс панелі.",
      "currentPanelVersion": "Поточна версія панелі",
      "latestPanelVersion": "Остання версія панелі",
      "panelUpToDate": "Панель оновлено",
      "upToDate": "Оновлено",
      "xrayStatusUnknown": "Невідомо",
      "xrayStatusRunning": "Запущено",
      "xrayStatusStop": "Зупинено",
      "xrayStatusError": "Помилка",
      "xrayErrorPopoverTitle": "Під час роботи Xray сталася помилка",
      "operationHours": "Час роботи",
      "systemHistoryTitle": "Історія системи",
      "charts": "Графіки",
      "xrayMetricsTitle": "Метрики Xray",
      "xrayMetricsDisabled": "Кінцева точка метрик Xray не налаштована",
      "xrayMetricsHint": "Додайте блок metrics верхнього рівня до конфігурації xray з tag metrics_out і listen 127.0.0.1:11111, потім перезапустіть xray.",
      "xrayObservatoryEmpty": "Даних Observatory ще немає",
      "xrayObservatoryHint": "Додайте блок observatory до конфігурації xray зі списком outbound тегів для перевірки, потім перезапустіть xray.",
      "xrayObservatoryTagPlaceholder": "Виберіть outbound",
      "xrayObservatoryAlive": "Активний",
      "xrayObservatoryDead": "Недоступний",
      "xrayObservatoryLastSeen": "Остання активність",
      "xrayObservatoryLastTry": "Остання спроба",
      "trendLast2Min": "Останні 2 хвилини",
      "systemLoad": "Завантаження системи",
      "systemLoadDesc": "Середнє завантаження системи за останні 1, 5 і 15 хвилин",
      "connectionCount": "Статистика з'єднання",
      "ipAddresses": "IP-адреси",
      "toggleIpVisibility": "Перемкнути видимість IP",
      "overallSpeed": "Загальна швидкість",
      "upload": "Завантаження",
      "download": "Завантажити",
      "totalData": "Загальний обсяг даних",
      "sent": "Відправлено",
      "received": "Отримано",
      "documentation": "Документація",
      "xraySwitchVersionDialog": "Ви дійсно хочете змінити версію Xray?",
      "xraySwitchVersionDialogDesc": "Це змінить версію Xray на #version#.",
      "xraySwitchVersionPopover": "Xray успішно оновлено",
      "panelUpdateDialog": "Ви дійсно хочете оновити панель?",
      "panelUpdateDialogDesc": "Це оновить 3X-UI до #version# та перезапустить сервіс панелі.",
      "panelUpdateCheckPopover": "Перевірка оновлення панелі не вдалася",
      "panelUpdateStartedPopover": "Розпочато оновлення панелі",
      "geofileUpdateDialog": "Ви дійсно хочете оновити геофайл?",
      "geofileUpdateDialogDesc": "Це оновить файл #filename#.",
      "geofilesUpdateDialogDesc": "Це оновить усі геофайли.",
      "geofilesUpdateAll": "Оновити все",
      "geofileUpdatePopover": "Геофайл успішно оновлено",
      "customGeoTitle": "Користувацькі GeoSite / GeoIP",
      "customGeoAdd": "Додати",
      "customGeoType": "Тип",
      "customGeoAlias": "Псевдонім",
      "customGeoUrl": "URL",
      "customGeoEnabled": "Увімкнено",
      "customGeoLastUpdated": "Оновлено",
      "customGeoExtColumn": "Маршрутизація (ext:…)",
      "customGeoToastUpdateAll": "Усі користувацькі джерела оновлено",
      "customGeoActions": "Дії",
      "customGeoEdit": "Змінити",
      "customGeoDelete": "Видалити",
      "customGeoDownload": "Оновити зараз",
      "customGeoModalAdd": "Додати користувацький geo",
      "customGeoModalEdit": "Змінити користувацький geo",
      "customGeoModalSave": "Зберегти",
      "customGeoDeleteConfirm": "Видалити це джерело geo?",
      "customGeoRoutingHint": "У правилах маршрутизації використовуйте значення як ext:файл.dat:тег (замініть тег).",
      "customGeoInvalidId": "Некоректний ідентифікатор ресурсу",
      "customGeoAliasesError": "Не вдалося завантажити псевдоніми geo",
      "customGeoValidationAlias": "Псевдонім: лише a-z, цифри, - і _",
      "customGeoValidationUrl": "URL має починатися з http:// або https://",
      "customGeoAliasPlaceholder": "a-z 0-9 _ -",
      "customGeoAliasLabelSuffix": " (власний)",
      "customGeoToastList": "Список користувацьких geo",
      "customGeoToastAdd": "Додати користувацький geo",
      "customGeoToastUpdate": "Оновити користувацький geo",
      "customGeoToastDelete": "Користувацький geofile «{{ .fileName }}» видалено",
      "customGeoToastDownload": "Geofile «{{ .fileName }}» оновлено",
      "customGeoErrInvalidType": "Тип має бути geosite або geoip",
      "customGeoErrAliasRequired": "Потрібен псевдонім",
      "customGeoErrAliasPattern": "Псевдонім містить недопустимі символи",
      "customGeoErrAliasReserved": "Цей псевдонім зарезервовано",
      "customGeoErrUrlRequired": "Потрібен URL",
      "customGeoErrInvalidUrl": "Некоректний URL",
      "customGeoErrUrlScheme": "URL має використовувати http або https",
      "customGeoErrUrlHost": "Некоректний хост URL",
      "customGeoErrDuplicateAlias": "Цей псевдонім уже використовується для цього типу",
      "customGeoErrNotFound": "Джерело geo не знайдено",
      "customGeoErrDownload": "Помилка завантаження",
      "customGeoErrUpdateAllIncomplete": "Не вдалося оновити один або кілька користувацьких джерел",
      "customGeoEmpty": "Користувацьких джерел geo поки немає — натисніть «Додати», щоб створити",
      "dontRefresh": "Інсталяція триває, будь ласка, не оновлюйте цю сторінку",
      "logs": "Логи",
      "config": "Конфігурація",
      "backup": "Резервна копія",
      "backupTitle": "Резервне копіювання та відновлення",
      "exportDatabase": "Резервна копія",
      "exportDatabaseDesc": "Натисніть, щоб завантажити файл .db, що містить резервну копію вашої поточної бази даних на ваш пристрій.",
      "importDatabase": "Відновити",
      "importDatabaseDesc": "Натисніть, щоб вибрати та завантажити файл .db з вашого пристрою для відновлення бази даних з резервної копії.",
      "importDatabaseSuccess": "Базу даних успішно імпортовано",
      "importDatabaseError": "Виникла помилка під час імпорту бази даних",
      "readDatabaseError": "Виникла помилка під час читання бази даних",
      "getDatabaseError": "Виникла помилка під час отримання бази даних",
      "getConfigError": "Виникла помилка під час отримання файлу конфігурації"
    },
    "inbounds": {
      "title": "Вхідні",
      "totalDownUp": "Всього надісланих/отриманих",
      "totalUsage": "Всього використанно",
      "inboundCount": "Загальна кількість вхідних",
      "operate": "Меню",
      "enable": "Увімкнено",
      "remark": "Примітка",
      "node": "Вузол",
      "deployTo": "Розгорнути на",
      "localPanel": "Локальна панель",
      "fallbacks": {
        "title": "Fallback'и",
        "help": "Коли з'єднання на цьому інбаунді не збігається з жодним клієнтом, воно перенаправляється на інший інбаунд. Оберіть дочірній інбаунд нижче — поля маршрутизації (SNI / ALPN / Path / xver) заповняться автоматично з його транспорту; для більшості налаштувань більше нічого змінювати не треба. Кожен дочірній має слухати на 127.0.0.1 з security=none.",
        "empty": "Фолбеків поки немає",
        "add": "Додати фолбек",
        "pickInbound": "Оберіть інбаунд",
        "matchAny": "будь-який",
        "destPlaceholder": "авто (listen:порт дочірнього)",
        "rederive": "Заповнити з дочірнього",
        "rederived": "Заповнено з дочірнього",
        "editAdvanced": "Редагувати поля маршрутизації",
        "hideAdvanced": "Сховати розширені",
        "quickAddAll": "Швидко додати всі придатні",
        "quickAdded": "Додано {n} фолбек(ів)",
        "quickAddedNone": "Немає нових придатних інбаундів",
        "routesWhen": "Маршрутизує, коли",
        "defaultCatchAll": "За замовчуванням — ловить усе інше"
      },
      "protocol": "Протокол",
      "port": "Порт",
      "portMap": "Відображення портів",
      "traffic": "Трафік",
      "details": "Деталі",
      "transportConfig": "Транспорт",
      "expireDate": "Тривалість",
      "createdAt": "Створено",
      "updatedAt": "Оновлено",
      "resetTraffic": "Скинути трафік",
      "addInbound": "Додати вхідний",
      "generalActions": "Загальні дії",
      "modifyInbound": "Змінити вхідний",
      "deleteInbound": "Видалити вхідні",
      "deleteInboundContent": "Ви впевнені, що хочете видалити вхідні?",
      "deleteConfirmTitle": "Видалити вхідні \"{remark}\"?",
      "deleteConfirmContent": "Це видалить вхідні та всіх його клієнтів. Цю дію неможливо скасувати.",
      "resetConfirmTitle": "Скинути трафік \"{remark}\"?",
      "resetConfirmContent": "Скидає лічильники відправки/отримання цього вхідного до 0.",
      "cloneConfirmTitle": "Клонувати вхідні \"{remark}\"?",
      "cloneConfirmContent": "Створює копію з новим портом і порожнім списком клієнтів.",
      "delAllClients": "Видалити всіх клієнтів",
      "delAllClientsConfirmTitle": "Видалити всіх {count} клієнтів із \"{remark}\"?",
      "delAllClientsConfirmContent": "Видаляє всіх клієнтів цього вхідного й скидає їхні записи трафіку. Сам вхідний зберігається. Цю дію не можна скасувати.",
      "attachClients": "Прив'язати клієнтів до…",
      "addClientsToGroup": "Додати клієнтів до групи…",
      "attachClientsTitle": "Прив'язати клієнтів з «{remark}»",
      "attachClientsDesc": "Прив'язує тих самих {count} клієнт(ів) (з тим самим UUID/паролем і спільним трафіком) до обраних вхідних. Вони залишаються і на цьому вхідному.",
      "attachClientsTargets": "Цільові вхідні",
      "attachClientsNoTargets": "Немає інших сумісних вхідних для прив'язки.",
      "attachClientsResult": "Прив'язано {attached}, пропущено {skipped}.",
      "attachClientsResultMixed": "Прив'язано {attached}, пропущено {skipped}, помилок {errors}.",
      "attachClientsSelectLabel": "Клієнти для прив'язки",
      "attachClientsSearchPlaceholder": "Пошук email або коментаря",
      "attachClientsStatusDisabled": "Вимкнено",
      "attachClientsSelectedCount": "Обрано {selected} з {total}",
      "detachClients": "Від'єднати клієнтів",
      "detachClientsTitle": "Від'єднати клієнтів з «{remark}»",
      "detachClientsDesc": "Видаляє обраних клієнт(ів) лише з цього вхідного. Записи клієнтів зберігаються (використовуйте Delete для повного видалення). У джерела всього {count} клієнт(ів).",
      "detachClientsResult": "Від'єднано {detached}, пропущено {skipped}.",
      "detachClientsResultMixed": "Від'єднано {detached}, пропущено {skipped}, помилок {errors}.",
      "detachClientsSelectLabel": "Клієнти для від'єднання",
      "exportLinksTitle": "Експортувати посилання вхідних",
      "exportSubsTitle": "Експортувати посилання підписок",
      "exportAllLinksTitle": "Експортувати всі посилання вхідних",
      "exportAllSubsTitle": "Експортувати всі посилання підписок",
      "exportAllLinksFileName": "Усі-вхідні",
      "exportAllSubsFileName": "Усі-вхідні-Subs",
      "inboundJsonTitle": "JSON вхідного",
      "deleteClient": "Видалити клієнта",
      "deleteClientContent": "Ви впевнені, що хочете видалити клієнт?",
      "resetTrafficContent": "Ви впевнені, що хочете скинути трафік?",
      "copyLink": "Копіювати URL",
      "address": "Адреса",
      "network": "Мережа",
      "destinationPort": "Порт призначення",
      "targetAddress": "Цільова адреса",
      "monitorDesc": "Залиште порожнім, щоб слухати всі IP-адреси",
      "meansNoLimit": "= Без обмежень. (одиниця: ГБ)",
      "totalFlow": "Загальна витрата",
      "leaveBlankToNeverExpire": "Залиште порожнім, щоб ніколи не закінчувався",
      "noRecommendKeepDefault": "Рекомендується зберегти значення за замовчуванням",
      "certificatePath": "Шлях до файлу",
      "certificateContent": "Вміст файлу",
      "publicKey": "Публічний ключ",
      "privatekey": "Закритий ключ",
      "clickOnQRcode": "Натисніть QR-код, щоб скопіювати",
      "client": "Клієнт",
      "export": "Експортувати всі URL-адреси",
      "clone": "Клон",
      "cloneInbound": "Клонувати",
      "cloneInboundContent": "Усі налаштування цього вхідного потоку, крім порту, IP-адреси прослуховування та клієнтів, будуть застосовані до клону.",
      "cloneInboundOk": "Клонувати",
      "resetAllTraffic": "Скинути весь вхідний трафік",
      "resetAllTrafficTitle": "Скинути весь вхідний трафік",
      "resetAllTrafficContent": "Ви впевнені, що бажаєте скинути трафік усіх вхідних?",
      "resetInboundClientTraffics": "Скинути трафік клієнтів",
      "resetInboundClientTrafficTitle": "Скинути трафік клієнтів",
      "resetInboundClientTrafficContent": "Ви впевнені, що бажаєте скинути трафік клієнтів цього вхідного потоку?",
      "resetAllClientTraffics": "Скинути весь трафік клієнтів",
      "resetAllClientTrafficTitle": "Скинути весь трафік клієнтів",
      "resetAllClientTrafficContent": "Ви впевнені, що бажаєте скинути трафік усіх клієнтів?",
      "delDepletedClients": "Видалити вичерпані клієнти",
      "delDepletedClientsTitle": "Видалити вичерпані клієнти",
      "delDepletedClientsContent": "Ви впевнені, що хочете видалити всі вичерпані клієнти?",
      "email": "Email",
      "emailDesc": "Будь ласка, надайте унікальну адресу електронної пошти.",
      "IPLimit": "Обмеження IP",
      "IPLimitDesc": "Вимикає вхідний, якщо кількість перевищує встановлене значення. (0 = вимкнено)",
      "IPLimitlog": "Журнал IP",
      "IPLimitlogDesc": "Журнал історії IP-адрес. (щоб увімкнути вхідну після вимкнення, очистіть журнал)",
      "IPLimitlogclear": "Очистити журнал",
      "setDefaultCert": "Установити сертифікат з панелі",
      "setDefaultCertEmpty": "Для панелі не налаштовано сертифікат. Спочатку встановіть його в Налаштуваннях.",
      "streamTab": "Потік",
      "securityTab": "Безпека",
      "sniffingTab": "Сніфінг",
      "sniffingMetadataOnly": "Лише метадані",
      "sniffingRouteOnly": "Лише маршрутизація",
      "sniffingIpsExcluded": "Виключені IP",
      "sniffingDomainsExcluded": "Виключені домени",
      "decryption": "Розшифрування",
      "encryption": "Шифрування",
      "vlessAuthX25519": "Автентифікація X25519",
      "vlessAuthMlkem768": "Автентифікація ML-KEM-768",
      "vlessAuthCustom": "Користувацький",
      "vlessAuthSelected": "Вибрано: {auth}",
      "advanced": {
        "title": "Розділи JSON вхідного",
        "subtitle": "Повний JSON вхідного та окремі редактори для settings, sniffing і streamSettings.",
        "all": "Усе",
        "allHelp": "Повний об'єкт вхідного з усіма полями в одному редакторі.",
        "settings": "Налаштування",
        "settingsHelp": "Обгортка блоку settings Xray:",
        "sniffing": "Sniffing",
        "sniffingHelp": "Обгортка блоку sniffing Xray:",
        "stream": "Stream",
        "streamHelp": "Обгортка блоку stream Xray:",
        "jsonErrorPrefix": "Розширений JSON"
      },
      "telegramDesc": "Будь ласка, вкажіть ID чату Telegram. (використовуйте команду '/id' у боті) або ({'@'}userinfobot)",
      "subscriptionDesc": "Щоб знайти URL-адресу вашої підписки, перейдіть до «Деталі». Крім того, ви можете використовувати одне ім'я для кількох клієнтів.",
      "same": "Те саме",
      "inboundData": "Вхідні дані",
      "exportInbound": "Експортувати вхідні",
      "import": "Імпорт",
      "importInbound": "Імпортувати вхідний",
      "periodicTrafficResetTitle": "Скидання трафіку",
      "periodicTrafficResetDesc": "Автоматично скидати лічильник трафіку через певні проміжки часу",
      "lastReset": "Останнє скидання",
      "periodicTrafficReset": {
        "never": "Ніколи",
        "daily": "Щодня",
        "weekly": "Щотижня",
        "monthly": "Щомісяця",
        "hourly": "Щогодини"
      },
      "toasts": {
        "obtain": "Отримати",
        "updateSuccess": "Оновлення пройшло успішно",
        "logCleanSuccess": "Журнал очищено",
        "inboundsUpdateSuccess": "Вхідні підключення успішно оновлено",
        "inboundUpdateSuccess": "Вхідне підключення успішно оновлено",
        "inboundCreateSuccess": "Вхідне підключення успішно створено",
        "inboundDeleteSuccess": "Вхідне підключення успішно видалено",
        "inboundClientAddSuccess": "Клієнт(и) вхідного підключення додано",
        "inboundClientDeleteSuccess": "Клієнта вхідного підключення видалено",
        "inboundClientUpdateSuccess": "Клієнта вхідного підключення оновлено",
        "delDepletedClientsSuccess": "Усі вичерпані клієнти видалені",
        "resetAllClientTrafficSuccess": "Весь трафік клієнта скинуто",
        "resetAllTrafficSuccess": "Весь трафік скинуто",
        "resetInboundClientTrafficSuccess": "Трафік скинуто",
        "resetInboundTrafficSuccess": "Трафік вхідного потоку скинуто",
        "trafficGetError": "Помилка отримання даних про трафік",
        "getNewX25519CertError": "Помилка при отриманні сертифіката X25519.",
        "getNewmldsa65Error": "Помилка при отриманні сертифіката mldsa65.",
        "getNewVlessEncError": "Помилка при отриманні сертифіката VlessEnc."
      },
      "form": {
        "moveUp": "Вгору",
        "moveDown": "Вниз",
        "addAll": "Додати всі",
        "addAllFallbackTooltip": "Додає рядок fallback для кожного придатного вхідного, ще не приєднаного",
        "peers": "Peers",
        "addPeer": "Додати peer",
        "keepAlive": "Keep-alive",
        "autoSystemRoutesTooltip": "Лише для Windows. CIDR'и автоматично додаються до системної таблиці маршрутизації, щоб відповідний трафік проходив через TUN.",
        "autoOutboundsInterface": "Авто-інтерфейс вихідних",
        "autoOutboundsInterfaceTooltip": "Фізичний інтерфейс для вихідного трафіку. Використовуйте 'auto' для виявлення; вмикається автоматично, коли налаштовано Auto system routes.",
        "rewriteAddress": "Переписати адресу",
        "rewritePort": "Переписати порт",
        "allowedNetwork": "Дозволена мережа",
        "followRedirect": "Слідувати redirect",
        "accounts": "Акаунти",
        "allowTransparent": "Дозволити прозорий",
        "encryptionMethod": "Метод шифрування",
        "visionTestseed": "Vision testseed",
        "version": "Версія",
        "udpIdleTimeout": "UDP idle timeout (с)",
        "masquerade": "Masquerade",
        "type": "Тип",
        "upstreamUrl": "Upstream URL",
        "rewriteHost": "Переписати Host",
        "skipTlsVerify": "Пропустити TLS verify",
        "directory": "Каталог",
        "statusCode": "Код статусу",
        "body": "Body",
        "headers": "Заголовки",
        "proxyProtocol": "Proxy Protocol",
        "requestVersion": "Версія запиту",
        "requestMethod": "Метод запиту",
        "requestPath": "Шлях запиту",
        "requestHeaders": "Заголовки запиту",
        "responseVersion": "Версія відповіді",
        "responseStatus": "Статус відповіді",
        "responseReason": "Причина відповіді",
        "responseHeaders": "Заголовки відповіді",
        "heartbeatPeriod": "Період heartbeat",
        "serviceName": "Назва сервісу",
        "authority": "Authority",
        "multiMode": "Multi Mode",
        "maxBufferedUpload": "Макс. буферизоване завантаження",
        "maxUploadSize": "Макс. розмір завантаження (байт)",
        "streamUpServer": "Stream-Up Server",
        "serverMaxHeaderBytes": "Server Max Header Bytes",
        "paddingBytes": "Padding Bytes",
        "uplinkHttpMethod": "HTTP-метод Uplink",
        "paddingObfsMode": "Padding Obfs Mode",
        "paddingKey": "Padding Key",
        "paddingHeader": "Padding Header",
        "paddingPlacement": "Padding Placement",
        "paddingMethod": "Padding Method",
        "sessionPlacement": "Session Placement",
        "sessionKey": "Session Key",
        "sequencePlacement": "Sequence Placement",
        "sequenceKey": "Sequence Key",
        "uplinkDataPlacement": "Uplink Data Placement",
        "uplinkDataKey": "Uplink Data Key",
        "noSseHeader": "Без заголовка SSE",
        "ttiMs": "TTI (мс)",
        "uplinkMbps": "Uplink (МБ/с)",
        "downlinkMbps": "Downlink (МБ/с)",
        "cwndMultiplier": "Множник CWND",
        "maxSendingWindow": "Макс. вікно відправки",
        "externalProxy": "External Proxy",
        "sniPlaceholder": "SNI (за замовчуванням = host)",
        "fingerprint": "Fingerprint",
        "defaultOption": "За замовчуванням",
        "routeMark": "Route Mark",
        "tcpKeepAliveInterval": "TCP Keep Alive Interval",
        "tcpKeepAliveIdle": "TCP Keep Alive Idle",
        "tcpMaxSeg": "TCP Max Seg",
        "tcpUserTimeout": "TCP User Timeout",
        "tcpWindowClamp": "TCP Window Clamp",
        "tcpFastOpen": "TCP Fast Open",
        "multipathTcp": "Multipath TCP",
        "penetrate": "Penetrate",
        "v6Only": "Лише V6",
        "tcpCongestion": "TCP Congestion",
        "dialerProxy": "Dialer Proxy",
        "trustedXForwardedFor": "Довірений X-Forwarded-For",
        "addressPortStrategy": "Стратегія адрес+порт",
        "tryDelayMs": "Затримка спроби (мс)",
        "prioritizeIPv6": "Пріоритет IPv6",
        "interleave": "Interleave",
        "maxConcurrentTry": "Макс. одночасних спроб",
        "customSockopt": "Користувацький sockopt",
        "addCustomOption": "Додати опцію",
        "serverNameIndication": "SNI",
        "cipherSuites": "Cipher Suites",
        "autoOption": "Авто",
        "minMaxVersion": "Мін/Макс версія",
        "rejectUnknownSni": "Відхиляти невідомий SNI",
        "disableSystemRoot": "Вимкнути System Root",
        "sessionResumption": "Відновлення сесії",
        "oneTimeLoading": "Одноразове завантаження",
        "usageOption": "Опція використання",
        "buildChain": "Build Chain",
        "echKey": "ECH key",
        "echConfig": "ECH config",
        "pinnedPeerCertSha256": "Закріплений SHA-256 сертифіката пира",
        "pinnedPeerCertSha256Tip": "SHA-256-хеші сертифіката пира в кодуванні Base64. Лише панель — не записується в конфіг xray сервера, але додається до посилань спільного доступу, щоб клієнти могли закріпити сертифікат.",
        "pinnedPeerCertSha256Placeholder": "Base64-хеш(і), через кому",
        "generateRandomPin": "Згенерувати випадковий хеш",
        "getNewEchCert": "Отримати новий ECH-сертифікат",
        "show": "Показати",
        "xver": "Xver",
        "target": "Ціль",
        "maxTimeDiff": "Макс. різниця в часі (мс)",
        "minClientVer": "Мін. версія клієнта",
        "maxClientVer": "Макс. версія клієнта",
        "shortIds": "Short IDs",
        "spiderX": "SpiderX",
        "getNewCert": "Отримати новий сертифікат",
        "mldsa65Seed": "mldsa65 Seed",
        "mldsa65Verify": "mldsa65 Verify",
        "getNewSeed": "Отримати новий Seed"
      },
      "info": {
        "mode": "Режим",
        "grpcServiceName": "grpc serviceName",
        "grpcMultiMode": "grpc multiMode",
        "interfaceName": "Назва інтерфейсу",
        "mtu": "MTU",
        "gateway": "Gateway",
        "dns": "DNS",
        "outboundsInterface": "Інтерфейс вихідних",
        "autoSystemRoutes": "Авто-маршрути системи",
        "followRedirect": "FollowRedirect",
        "auth": "Auth",
        "noKernelTun": "TUN без kernel",
        "keepAlive": "Keep alive",
        "peerNumber": "Peer {n}",
        "peerNumberConfig": "Конфіг Peer {n}"
      },
      "stream": {
        "general": {
          "request": "Запит",
          "response": "Відповідь",
          "name": "Ім'я",
          "value": "Значення"
        },
        "tcp": {
          "version": "Версія",
          "method": "Метод",
          "path": "Шлях",
          "status": "Статус",
          "statusDescription": "Опис стану",
          "requestHeader": "Заголовок запиту",
          "responseHeader": "Заголовок відповіді"
        }
      }
    },
    "clients": {
      "add": "Додати клієнта",
      "edit": "Редагувати клієнта",
      "submitAdd": "Додати клієнта",
      "submitEdit": "Зберегти зміни",
      "clientCount": "Кількість клієнтів",
      "bulk": "Масове додавання",
      "copyFromInbound": "Скопіювати клієнтів із вхідного",
      "copyToInbound": "Скопіювати клієнтів у",
      "copySelected": "Скопіювати вибране",
      "copySource": "Джерело",
      "copyEmailPreview": "Перегляд email, що буде створено",
      "copySelectSourceFirst": "Спочатку виберіть вхідний-джерело.",
      "copyResult": "Результат копіювання",
      "copyResultSuccess": "Скопійовано успішно",
      "copyResultNone": "Нічого копіювати: не вибрано клієнтів або джерело порожнє",
      "copyResultErrors": "Помилки копіювання",
      "copyFlowLabel": "Flow для нових клієнтів (VLESS)",
      "copyFlowHint": "Застосовується до всіх скопійованих клієнтів. Залишіть порожнім, щоб пропустити.",
      "selectAll": "Вибрати все",
      "clearAll": "Очистити все",
      "method": "Метод",
      "first": "Перший",
      "last": "Останній",
      "ipLog": "Журнал IP",
      "prefix": "Префікс",
      "postfix": "Постфікс",
      "delayedStart": "Запуск після першого використання",
      "expireDays": "Тривалість",
      "days": "Дні",
      "renew": "Авто-продовження",
      "renewDesc": "Автоматичне продовження після закінчення. (0 = вимкнено) (одиниця: день)",
      "searchPlaceholder": "Пошук email, коментаря, sub ID, UUID, паролю, auth…",
      "filterTitle": "Фільтр клієнтів",
      "clearAllFilters": "Очистити все",
      "sortOldest": "Спочатку старі",
      "sortNewest": "Спочатку нові",
      "sortRecentlyUpdated": "Нещодавно оновлені",
      "sortRecentlyOnline": "Нещодавно у мережі",
      "sortEmailAZ": "Email А→Я",
      "sortEmailZA": "Email Я→А",
      "sortMostTraffic": "Більше трафіку",
      "sortHighestRemaining": "Більше залишку",
      "sortExpiringSoonest": "Швидше закінчуються",
      "has": "Має",
      "hasNot": "Не має",
      "title": "Клієнти",
      "actions": "Дії",
      "totalGB": "Усього надіслано/отримано (ГБ)",
      "expiryTime": "Термін дії",
      "addClients": "Додати клієнтів",
      "limitIp": "Ліміт IP",
      "password": "Пароль",
      "subId": "ID підписки",
      "online": "У мережі",
      "email": "Email",
      "group": "Група",
      "groupDesc": "Логічна мітка для групування пов'язаних клієнтів (напр. команда, клієнт, регіон). Фільтрується з панелі інструментів.",
      "groupPlaceholder": "напр. customer-a",
      "comment": "Коментар",
      "traffic": "Трафік",
      "offline": "Не в мережі",
      "addTitle": "Додати клієнта",
      "qrCode": "QR-код",
      "moreInformation": "Докладніше",
      "delete": "Видалити",
      "reset": "Скинути трафік",
      "editTitle": "Редагувати клієнта",
      "client": "Клієнт",
      "enabled": "Увімкнено",
      "remaining": "Залишок",
      "duration": "Тривалість",
      "attachedInbounds": "Прив'язані вхідні",
      "selectInbound": "Виберіть один або кілька вхідних",
      "noSubId": "У цього клієнта немає subId, посилання для спільного доступу відсутнє.",
      "noLinks": "Немає посилань для спільного доступу — спочатку прив'яжіть цього клієнта до вхідного з підтримкою протоколу.",
      "link": "Посилання",
      "resetNotPossible": "Спочатку прив'яжіть цього клієнта до вхідного.",
      "general": "Загальне",
      "resetAllTraffics": "Скинути трафік усіх клієнтів",
      "resetAllTrafficsTitle": "Скинути трафік усіх клієнтів?",
      "resetAllTrafficsContent": "Лічильники відправлення/отримання кожного клієнта обнулюються. Квоти й термін дії не змінюються. Цю дію неможливо скасувати.",
      "deleteConfirmTitle": "Видалити клієнта {email}?",
      "deleteConfirmContent": "Клієнт буде вилучений з усіх прив'язаних вхідних, його запис трафіку буде знищено. Цю дію неможливо скасувати.",
      "deleteSelected": "Видалити ({count})",
      "adjustSelected": "Змінити ({count})",
      "subLinksSelected": "Sub-посилання ({count})",
      "addToGroupTitle": "Додати {count} клієнт(ів) до групи",
      "addToGroupTooltip": "Виберіть існуючу групу або введіть нову назву. Використовуйте Ungroup, щоб вилучити клієнтів із поточної групи.",
      "addToGroupPlaceholder": "Назва групи",
      "addToGroupSuccessToast": "{count} клієнт(ів) додано до {group}",
      "ungroupSuccessToast": "Групу очищено у {count} клієнт(ів)",
      "ungroup": "Розгрупувати",
      "ungroupConfirmTitle": "Видалити {count} клієнт(ів) з їхньої групи?",
      "ungroupConfirmContent": "Очищує мітку групи у кожного обраного клієнта. Самі клієнти зберігаються (використовуйте Delete для повного видалення).",
      "addToGroup": "Додати до групи",
      "attach": "Прив'язати",
      "adjust": "Коригування",
      "subLinks": "Sub-посилання",
      "selectedCount": "Обрано {count}",
      "attachSelected": "Прив'язати ({count})",
      "attachToInboundsTitle": "Прив'язати {count} клієнт(ів) до вхідних",
      "attachToInboundsDesc": "Прив'язує обрані {count} клієнт(ів) (той самий UUID/пароль і спільний трафік) до обраних вхідних. Існуючі прив'язки зберігаються.",
      "attachToInboundsTargets": "Цільові вхідні",
      "attachToInboundsNoTargets": "Немає доступних багатокористувацьких вхідних для прив'язки.",
      "detachSelected": "Від'єднати ({count})",
      "detach": "Від'єднати",
      "detachFromInboundsTitle": "Від'єднати {count} клієнт(ів) від вхідних",
      "detachFromInboundsDesc": "Видаляє обраних {count} клієнт(ів) з обраних вхідних. Пари, де клієнт не був прив'язаний, тихо пропускаються. Записи клієнтів зберігаються (використовуйте Delete для повного видалення).",
      "detachFromInboundsTargets": "Вхідні для від'єднання",
      "detachFromInboundsNoTargets": "Немає доступних багатокористувацьких вхідних.",
      "detachFromInboundsResult": "Від'єднано {detached}, пропущено {skipped}.",
      "detachFromInboundsResultMixed": "Від'єднано {detached}, пропущено {skipped}, помилок {errors}.",
      "subLinksTitle": "Sub-посилання ({count})",
      "subLinkColumn": "URL підписки",
      "subJsonLinkColumn": "URL JSON-підписки",
      "subLinksCopyAll": "Копіювати все",
      "subLinksCopiedAll": "Скопійовано {count} посилань",
      "subLinksEmpty": "Жоден з обраних клієнтів не має ID підписки.",
      "subLinksDisabled": "Сервіс підписки вимкнено.",
      "subLinksDisabledHint": "Увімкніть підписку в Налаштування панелі → Підписка для генерації посилань.",
      "bulkDeleteConfirmTitle": "Видалити {count} клієнтів?",
      "bulkDeleteConfirmContent": "Кожен вибраний клієнт вилучається з усіх прив'язаних вхідних, його запис трафіку знищується. Цю дію неможливо скасувати.",
      "bulkAdjustTitle": "Змінити {count} клієнтів",
      "bulkAdjustHint": "Додатні значення подовжують, від'ємні зменшують. Клієнти з необмеженим терміном або трафіком пропускаються для відповідного поля.",
      "bulkAdjustNothing": "Вкажіть дні або трафік перед застосуванням.",
      "addDays": "Додати дні",
      "addTrafficGB": "Додати трафік (ГБ)",
      "delDepleted": "Видалити вичерпаних",
      "delDepletedConfirmTitle": "Видалити вичерпаних клієнтів?",
      "delDepletedConfirmContent": "Видаляються всі клієнти, у яких вичерпана квота трафіку або сплив термін. Цю дію неможливо скасувати.",
      "auth": "Авторизація",
      "hysteriaAuth": "Hysteria Auth",
      "uuid": "UUID",
      "flow": "Flow",
      "vmessSecurity": "Безпека VMess",
      "reverseTag": "Зворотний тег",
      "reverseTagPlaceholder": "Необов'язковий Reverse tag",
      "telegramId": "ID користувача Telegram",
      "telegramIdPlaceholder": "Числовий ID користувача Telegram (0 = немає)",
      "created": "Створено",
      "updated": "Оновлено",
      "ipLimit": "Ліміт IP",
      "toasts": {
        "deleted": "Клієнта видалено",
        "trafficReset": "Трафік скинуто",
        "allTrafficsReset": "Трафік усіх клієнтів скинуто",
        "bulkDeleted": "Видалено клієнтів: {count}",
        "bulkDeletedMixed": "Видалено: {ok}, не вдалось: {failed}",
        "bulkCreated": "Створено клієнтів: {count}",
        "bulkCreatedMixed": "Створено: {ok}, не вдалось: {failed}",
        "bulkAdjusted": "Змінено клієнтів: {count}",
        "bulkAdjustedMixed": "Змінено: {ok}, пропущено: {skipped}",
        "delDepleted": "Видалено вичерпаних клієнтів: {count}"
      }
    },
    "groups": {
      "title": "Групи",
      "name": "Назва",
      "clientCount": "Клієнтів у групі",
      "totalGroups": "Всього груп",
      "totalGroupedClients": "Клієнти з групою",
      "emptyGroups": "Порожні групи",
      "addGroup": "Додати групу",
      "createSuccess": "Групу «{name}» створено.",
      "rename": "Перейменувати",
      "renameTitle": "Перейменувати {name}",
      "renameCollision": "Група з назвою «{name}» вже існує.",
      "renameSuccess": "Групу перейменовано на {count} клієнт(ах).",
      "deleteConfirmTitle": "Видалити групу {name}?",
      "deleteConfirmContent": "Це видаляє групу й очищує її мітку у {count} клієнт(ів). Самі клієнти не видаляються.",
      "deleteSuccess": "Групу очищено у {count} клієнт(ів).",
      "resetTraffic": "Скинути трафік",
      "resetConfirmTitle": "Скинути трафік групи {name}?",
      "resetConfirmContent": "Це обнулить up/down для всіх {count} клієнт(ів) у цій групі.",
      "resetSuccess": "Скинуто трафік у {count} клієнт(ів).",
      "adjustSuccess": "Скориговано {count} клієнт(ів) у {name}.",
      "emptyForAction": "У цій групі ще немає клієнтів.",
      "deleteGroupOnly": "Видалити групу (зберегти клієнтів)",
      "deleteClients": "Видалити клієнтів групи",
      "deleteClientsConfirmTitle": "Видалити всіх клієнтів у {name}?",
      "deleteClientsConfirmContent": "Це безповоротно видалить {count} клієнт(ів) разом з їхніми записами трафіку. Мітка групи також очищується. Дію не можна скасувати.",
      "deleteClientsSuccess": "Видалено {count} клієнт(ів).",
      "deleteClientsMixed": "{ok} видалено, {failed} пропущено",
      "addToGroup": "Додати клієнтів…",
      "addToGroupTitle": "Додати клієнтів до групи «{name}»",
      "addToGroupDesc": "Виберіть клієнтів для додавання в цю групу. Існуючі прив'язки до вхідних зберігаються; змінюється лише мітка групи. Клієнти, які вже в цій групі, не відображаються.",
      "addToGroupEmpty": "Немає інших клієнтів для додавання.",
      "addToGroupResult": "Додано {count} клієнт(ів) до {name}.",
      "removeFromGroup": "Видалити клієнтів…",
      "removeFromGroupTitle": "Видалити клієнтів з групи «{name}»",
      "removeFromGroupDesc": "Виберіть учасників для видалення з цієї групи. Самі клієнти зберігаються (використовуйте «Видалити клієнтів групи» для повного видалення).",
      "removeFromGroupResult": "Видалено {count} клієнт(ів) з {name}."
    },
    "nodes": {
      "title": "Вузли",
      "addNode": "Додати вузол",
      "editNode": "Змінити вузол",
      "totalNodes": "Усього вузлів",
      "onlineNodes": "У мережі",
      "offlineNodes": "Не в мережі",
      "avgLatency": "Середня затримка",
      "name": "Назва",
      "namePlaceholder": "напр. de-frankfurt-1",
      "addressPlaceholder": "panel.example.com або 1.2.3.4",
      "remark": "Примітка",
      "scheme": "Схема",
      "address": "Адреса",
      "port": "Порт",
      "basePath": "Базовий шлях",
      "apiToken": "API Token",
      "apiTokenPlaceholder": "Токен зі сторінки Налаштувань віддаленої панелі",
      "apiTokenHint": "Віддалена панель показує свій токен API в Налаштуваннях → Токен API.",
      "regenerate": "Перегенерувати токен",
      "regenerateConfirm": "Перегенерація скасовує поточний токен. Будь-яка центральна панель, що його використовує, втратить доступ до оновлення. Продовжити?",
      "allowPrivateAddress": "Дозволити приватну адресу",
      "allowPrivateAddressHint": "Увімкнути лише для вузлів у приватній мережі або VPN.",
      "enable": "Увімкнено",
      "status": "Статус",
      "cpu": "CPU",
      "mem": "Пам'ять",
      "uptime": "Час роботи",
      "latency": "Затримка",
      "lastHeartbeat": "Останній пінг",
      "xrayVersion": "Версія Xray",
      "panelVersion": "Версія панелі",
      "actions": "Дії",
      "probe": "Перевірити зараз",
      "testConnection": "Перевірити з'єднання",
      "connectionOk": "З'єднання в порядку ({ms} мс)",
      "connectionFailed": "Помилка з'єднання",
      "never": "ніколи",
      "justNow": "щойно",
      "deleteConfirmTitle": "Видалити вузол \"{name}\"?",
      "deleteConfirmContent": "Це зупинить моніторинг вузла. Сама віддалена панель не зазнає змін.",
      "statusValues": {
        "online": "У мережі",
        "offline": "Не в мережі",
        "unknown": "Невідомо"
      },
      "toasts": {
        "list": "Не вдалося завантажити вузли",
        "obtain": "Не вдалося завантажити вузол",
        "add": "Додати вузол",
        "update": "Оновити вузол",
        "delete": "Видалити вузол",
        "deleted": "Вузол видалено",
        "test": "Перевірити з'єднання",
        "fillRequired": "Назва, адреса, порт та токен API є обов'язковими",
        "probeFailed": "Помилка перевірки"
      }
    },
    "settings": {
      "title": "Параметри панелі",
      "save": "Зберегти",
      "infoDesc": "Кожна внесена тут зміна повинна бути збережена. Перезапустіть панель, щоб застосувати зміни.",
      "restartPanel": "Перезапустити панель",
      "restartPanelDesc": "Ви впевнені, що бажаєте перезапустити панель? Якщо ви не можете отримати доступ до панелі після перезапуску, будь ласка, перегляньте інформацію журналу панелі на сервері.",
      "restartPanelSuccess": "Панель успішно перезапущено",
      "actions": "Дії",
      "resetDefaultConfig": "Відновити значення за замовчуванням",
      "panelSettings": "Загальні",
      "securitySettings": "Автентифікація",
      "securityWarnings": "Попередження безпеки",
      "panelExposed": "Ваша панель може бути відкрита:",
      "warnHttp": "Панель працює через звичайний HTTP — налаштуйте TLS для продакшну.",
      "warnDefaultPort": "Стандартний порт 2053 широко відомий — змініть його на випадковий.",
      "warnDefaultBasePath": "Базовий шлях за замовчуванням \"/\" широко відомий — змініть його на випадковий.",
      "warnDefaultSubPath": "Шлях підписки за замовчуванням \"/sub/\" широко відомий — змініть його.",
      "warnDefaultJsonPath": "JSON-шлях підписки за замовчуванням \"/json/\" широко відомий — змініть його.",
      "TGBotSettings": "Telegram-бот",
      "panelListeningIP": "Слухати IP",
      "panelListeningIPDesc": "IP-адреса для веб-панелі. (залиште порожнім, щоб слухати всі IP-адреси)",
      "panelListeningDomain": "Домен прослуховування",
      "panelListeningDomainDesc": "Доменне ім'я для веб-панелі. (залиште порожнім, щоб слухати всі домени та IP-адреси)",
      "panelPort": "Порт прослуховування",
      "panelPortDesc": "Номер порту для веб-панелі. (має бути невикористаний порт)",
      "publicKeyPath": "Шлях відкритого ключа",
      "publicKeyPathDesc": "Шлях до файлу відкритого ключа для веб-панелі. (починається з ‘/‘)",
      "privateKeyPath": "Шлях приватного ключа",
      "privateKeyPathDesc": "Шлях до файлу приватного ключа для веб-панелі. (починається з ‘/‘)",
      "panelUrlPath": "URI-шлях",
      "panelUrlPathDesc": "Шлях URL для веб-панелі. (починається з ‘/‘ і закінчується ‘/‘)",
      "pageSize": "Розмір сторінки",
      "pageSizeDesc": "Визначити розмір сторінки для вхідної таблиці. (0 = вимкнено)",
      "panelProxy": "Мережевий проксі панелі",
      "panelProxyDesc": "Маршрутизує власні вихідні запити панелі (оновлення geo, перевірки версій Xray/панелі, Telegram) через цей проксі для обходу фільтрації GitHub/Telegram на стороні сервера. Приймає socks5:// або http(s)://, напр. локальний SOCKS-вхідний Xray. Залиште порожнім для прямого підключення.",
      "remarkModel": "Модель зауваження та роздільний символ",
      "datepicker": "Тип календаря",
      "datepickerPlaceholder": "Виберіть дату",
      "datepickerDescription": "Заплановані завдання виконуватимуться на основі цього календаря.",
      "sampleRemark": "Зразок зауваження",
      "oldUsername": "Поточне ім'я користувача",
      "currentPassword": "Поточний пароль",
      "newUsername": "Нове ім'я користувача",
      "newPassword": "Новий пароль",
      "telegramBotEnable": "Увімкнути Telegram Bot",
      "telegramBotEnableDesc": "Вмикає бота Telegram.",
      "telegramToken": "Telegram-токен",
      "telegramTokenDesc": "Токен бота Telegram, отриманий від '{'@'}BotFather'.",
      "telegramProxy": "SOCKS-проксі",
      "telegramProxyDesc": "Вмикає проксі-сервер SOCKS5 для підключення до Telegram. (відкоригуйте параметри відповідно до посібника)",
      "telegramAPIServer": "Telegram API сервер",
      "telegramAPIServerDesc": "Сервер Telegram API для використання. Залиште поле порожнім, щоб використовувати сервер за умовчанням.",
      "telegramChatId": "Ідентифікатор чату адміністратора",
      "telegramChatIdDesc": "Ідентифікатори чату адміністратора Telegram. (розділені комами) (отримайте тут {'@'}userinfobot) або (використовуйте команду '/id' у боті)",
      "telegramNotifyTime": "Час сповіщення",
      "telegramNotifyTimeDesc": "Час повідомлення бота Telegram, встановлений для періодичних звітів. (використовуйте формат часу crontab)",
      "tgNotifyBackup": "Резервне копіювання бази даних",
      "tgNotifyBackupDesc": "Надіслати файл резервної копії бази даних зі звітом.",
      "tgNotifyLogin": "Сповіщення про вхід",
      "tgNotifyLoginDesc": "Отримувати сповіщення про ім'я користувача, IP-адресу та час щоразу, коли хтось намагається увійти у вашу веб-панель.",
      "sessionMaxAge": "Тривалість сеансу",
      "sessionMaxAgeDesc": "Тривалість, протягом якої ви можете залишатися в системі. (одиниця: хвилина)",
      "expireTimeDiff": "Повідомлення про дату закінчення",
      "expireTimeDiffDesc": "Отримувати сповіщення про термін дії при досягненні цього порогу. (одиниця: день)",
      "trafficDiff": "Повідомлення про обмеження трафіку",
      "trafficDiffDesc": "Отримувати сповіщення про обмеження трафіку при досягненні цього порогу. (одиниця: ГБ)",
      "tgNotifyCpu": "Сповіщення про завантаження ЦП",
      "tgNotifyCpuDesc": "Отримувати сповіщення, якщо навантаження ЦП перевищує це порогове значення. (одиниця: %)",
      "timeZone": "Часовий пояс",
      "timeZoneDesc": "Заплановані завдання виконуватимуться на основі цього часового поясу.",
      "subSettings": "Підписка",
      "subEnable": "Увімкнути службу підписки",
      "subEnableDesc": "Вмикає службу підписки.",
      "subJsonEnable": "Увімкнути/вимкнути JSON-кінець підписки незалежно.",
      "subJsonEnableTitle": "JSON-підписка",
      "subClashEnableTitle": "Підписка Clash / Mihomo",
      "subTitle": "Назва Підписки",
      "subTitleDesc": "Назва, яка відображається у VPN-клієнті",
      "subSupportUrl": "URL підтримки",
      "subSupportUrlDesc": "Посилання на технічну підтримку, що відображається у VPN-клієнті",
      "subProfileUrl": "URL профілю",
      "subProfileUrlDesc": "Посилання на ваш вебсайт, що відображається у VPN-клієнті",
      "subAnnounce": "Оголошення",
      "subAnnounceDesc": "Текст оголошення, що відображається у VPN-клієнті",
      "subEnableRouting": "Увімкнути маршрутизацію",
      "subEnableRoutingDesc": "Глобальне налаштування для увімкнення маршрутизації у VPN-клієнті. (Тільки для Happ)",
      "subRoutingRules": "Правила маршрутизації",
      "subRoutingRulesDesc": "Глобальні правила маршрутизації для VPN-клієнта. (Тільки для Happ)",
      "subListen": "Слухати IP",
      "subListenDesc": "IP-адреса для служби підписки. (залиште порожнім, щоб слухати всі IP-адреси)",
      "subPort": "Слухати порт",
      "subPortDesc": "Номер порту для служби підписки. (має бути невикористаний порт)",
      "subCertPath": "Шлях відкритого ключа",
      "subCertPathDesc": "Шлях до файлу відкритого ключа для служби підписки. (починається з ‘/‘)",
      "subKeyPath": "Шлях приватного ключа",
      "subKeyPathDesc": "Шлях до файлу приватного ключа для служби підписки. (починається з ‘/‘)",
      "subPath": "URI-шлях",
      "subPathDesc": "Шлях URI для служби підписки. (починається з ‘/‘ і закінчується ‘/‘)",
      "subDomain": "Домен прослуховування",
      "subDomainDesc": "Ім'я домену для служби підписки. (залиште порожнім, щоб слухати всі домени та IP-адреси)",
      "subUpdates": "Інтервали оновлення",
      "subUpdatesDesc": "Інтервали оновлення URL-адреси підписки в клієнтських програмах. (одиниця: година)",
      "subEncrypt": "Кодувати",
      "subEncryptDesc": "Повернений вміст послуги підписки матиме кодування Base64.",
      "subShowInfo": "Показати інформацію про використання",
      "subShowInfoDesc": "Залишок трафіку та дата відображатимуться в клієнтських програмах.",
      "subEmailInRemark": "Включати Email до назви",
      "subEmailInRemarkDesc": "Включати email клієнта до назви профілю підписки.",
      "subURI": "URI зворотного проксі",
      "subURIDesc": "URI до URL-адреси підписки для використання за проксі.",
      "externalTrafficInformEnable": "Інформація про зовнішній трафік",
      "externalTrafficInformEnableDesc": "Повідомляти зовнішній API про кожне оновлення трафіку.",
      "externalTrafficInformURI": "Інформаційний URI зовнішнього трафіку",
      "externalTrafficInformURIDesc": "Оновлення трафіку надсилаються на цей URI.",
      "restartXrayOnClientDisable": "Перезапускати Xray після авто-вимкнення",
      "restartXrayOnClientDisableDesc": "Коли клієнт автоматично вимикається через закінчення терміну дії або ліміт трафіку, перезапускати Xray.",
      "fragment": "Фрагментація",
      "fragmentDesc": "Увімкнути фрагментацію для пакету привітання TLS",
      "fragmentSett": "Параметри фрагментації",
      "noisesDesc": "Увімкнути Noises.",
      "noisesSett": "Налаштування Noises",
      "trustedProxyCidrs": "Довірені CIDR проксі",
      "trustedProxyCidrsDesc": "IP/CIDR через кому, яким дозволено встановлювати заголовки forwarded host, proto та client IP.",
      "ldap": {
        "enable": "Увімкнути LDAP-синхронізацію",
        "host": "LDAP-хост",
        "port": "Порт LDAP",
        "useTls": "Використовувати TLS (LDAPS)",
        "bindDn": "Bind DN",
        "passwordConfigured": "Налаштовано; залиште порожнім для збереження поточного паролю.",
        "passwordUnconfigured": "Не налаштовано.",
        "passwordPlaceholder": "Налаштовано — введіть нове значення для заміни",
        "baseDn": "Base DN",
        "userFilter": "Фільтр користувача",
        "userAttr": "Атрибут користувача (username/email)",
        "vlessField": "Атрибут VLESS-flag",
        "flagField": "Загальний атрибут flag (опц.)",
        "flagFieldDesc": "Якщо задано, перевизначає VLESS flag — напр. shadowInactive.",
        "truthyValues": "Truthy-значення",
        "truthyValuesDesc": "Через кому; за замовч.: true,1,yes,on",
        "invertFlag": "Інвертувати flag",
        "invertFlagDesc": "Увімкніть, коли атрибут означає «вимкнено» (напр. shadowInactive).",
        "syncSchedule": "Розклад синхронізації",
        "syncScheduleDesc": "Рядок типу cron, напр. @every 1m",
        "inboundTags": "Теги вхідних",
        "inboundTagsDesc": "Вхідні, на яких LDAP-синхронізація може авто-створювати або авто-видаляти клієнтів.",
        "noInbounds": "Вхідних не знайдено. Спочатку створіть один у Вхідних.",
        "autoCreate": "Авто-створення клієнтів",
        "autoDelete": "Авто-видалення клієнтів",
        "defaultTotalGb": "Обсяг за замовч. (ГБ)",
        "defaultExpiryDays": "Термін за замовч. (дні)",
        "defaultIpLimit": "Ліміт IP за замовч."
      },
      "subFormats": {
        "packets": "Пакети",
        "length": "Довжина",
        "interval": "Інтервал",
        "maxSplit": "Макс. розбиття",
        "noises": "Шуми",
        "noiseItem": "Шум №{n}",
        "type": "Тип",
        "packet": "Пакет",
        "delayMs": "Затримка (мс)",
        "applyTo": "Застосувати до",
        "addNoise": "+ Шум",
        "concurrency": "Паралельність",
        "xudpConcurrency": "Паралельність xudp",
        "xudpUdp443": "xudp UDP 443"
      },
      "mux": "Mux",
      "muxDesc": "Передавати кілька незалежних потоків даних у межах встановленого потоку даних.",
      "muxSett": "Налаштування Mux",
      "direct": "Пряме підключення",
      "directDesc": "Безпосередньо встановлює з’єднання з доменами або діапазонами IP певної країни.",
      "notifications": "Сповіщення",
      "certs": "Сертифікати",
      "externalTraffic": "Зовнішній трафік",
      "dateAndTime": "Дата та час",
      "proxyAndServer": "Проксі та сервер",
      "intervals": "Інтервали",
      "information": "Інформація",
      "language": "Мова",
      "telegramBotLanguage": "Мова Telegram-бота",
      "security": {
        "admin": "Облікові дані адміністратора",
        "twoFactor": "Двофакторна аутентифікація",
        "twoFactorEnable": "Увімкнути 2FA",
        "twoFactorEnableDesc": "Додає додатковий рівень аутентифікації для підвищення безпеки.",
        "twoFactorModalSetTitle": "Увімкнути двофакторну аутентифікацію",
        "twoFactorModalDeleteTitle": "Вимкнути двофакторну аутентифікацію",
        "twoFactorModalSteps": "Щоб налаштувати двофакторну аутентифікацію, виконайте кілька кроків:",
        "twoFactorModalFirstStep": "1. Відскануйте цей QR-код у програмі для аутентифікації або скопіюйте токен біля QR-коду та вставте його в програму",
        "twoFactorModalSecondStep": "2. Введіть код з програми",
        "twoFactorModalRemoveStep": "Введіть код з програми, щоб вимкнути двофакторну аутентифікацію.",
        "twoFactorModalChangeCredentialsTitle": "Змінити облікові дані",
        "twoFactorModalChangeCredentialsStep": "Введіть код з додатку, щоб змінити облікові дані адміністратора.",
        "twoFactorModalSetSuccess": "Двофакторна аутентифікація була успішно встановлена",
        "twoFactorModalDeleteSuccess": "Двофакторна аутентифікація була успішно видалена",
        "twoFactorModalError": "Невірний код",
        "show": "Показати",
        "hide": "Сховати",
        "apiTokenNew": "Новий токен",
        "apiTokenName": "Назва",
        "apiTokenNamePlaceholder": "наприклад, central-panel-a",
        "apiTokenNameRequired": "Назва обов'язкова",
        "apiTokenEmpty": "Поки немає токенів — створіть один для автентифікації ботів або віддалених панелей.",
        "apiTokenDeleteWarning": "Будь-який клієнт, що використовує цей токен, негайно втратить автентифікацію."
      },
      "toasts": {
        "modifySettings": "Параметри було змінено.",
        "getSettings": "Виникла помилка під час отримання параметрів.",
        "modifyUserError": "Виникла помилка під час зміни облікових даних адміністратора.",
        "modifyUser": "Ви успішно змінили облікові дані адміністратора.",
        "originalUserPassIncorrect": "Поточне ім'я користувача або пароль недійсні",
        "userPassMustBeNotEmpty": "Нове ім'я користувача та пароль порожні",
        "getOutboundTrafficError": "Помилка отримання вихідного трафіку",
        "resetOutboundTrafficError": "Помилка скидання вихідного трафіку"
      }
    },
    "xray": {
      "title": "Xray конфігурації",
      "save": "Зберегти",
      "restart": "Перезапуск Xray",
      "restartSuccess": "Xray успішно перезапущено",
      "restartOutputTitle": "Вивід перезапуску Xray",
      "restartConfirmTitle": "Перезапустити xray?",
      "restartConfirmContent": "Перезавантажує сервіс xray зі збереженою конфігурацією.",
      "stopSuccess": "Xray успішно зупинено",
      "restartError": "Виникла помилка під час перезапуску Xray.",
      "stopError": "Виникла помилка під час зупинки Xray.",
      "basicTemplate": "Базовий шаблон",
      "advancedTemplate": "Додатково",
      "generalConfigs": "Загальні конфігурації",
      "generalConfigsDesc": "Ці параметри визначатимуть загальні налаштування.",
      "logConfigs": "Лог",
      "logConfigsDesc": "Журнали можуть вплинути на ефективність вашого сервера. Рекомендується вмикати його з розумом лише у випадку ваших потреб",
      "blockConfigsDesc": "Ці параметри блокуватимуть трафік на основі конкретних запитуваних протоколів і веб-сайтів.",
      "basicRouting": "Основна Маршрутизація",
      "blockConnectionsConfigsDesc": "Ці параметри блокуватимуть трафік на основі запитаних країн.",
      "directConnectionsConfigsDesc": "Пряме з'єднання гарантує, що певний трафік не буде маршрутизовано через інший сервер.",
      "blockips": "Блокувати IP",
      "blockdomains": "Блокувати домени",
      "directips": "Прямі IP",
      "directdomains": "Прямі домени",
      "ipv4Routing": "Маршрутизація IPv4",
      "ipv4RoutingDesc": "Ці параметри спрямовуватимуть трафік на основі певного призначення через IPv4.",
      "warpRouting": "WARP Маршрутизація",
      "warpRoutingDesc": "Ці параметри маршрутизуватимуть трафік на основі певного пункту призначення через WARP.",
      "nordRouting": "Маршрутизація NordVPN",
      "nordRoutingDesc": "Ці параметри маршрутизуватимуть трафік на основі певного пункту призначення через NordVPN.",
      "Template": "Шаблон розширеної конфігурації Xray",
      "TemplateDesc": "Остаточний конфігураційний файл Xray буде створено на основі цього шаблону.",
      "FreedomStrategy": "Стратегія протоколу свободи",
      "FreedomStrategyDesc": "Установити стратегію виведення для мережі в протоколі свободи.",
      "RoutingStrategy": "Загальна стратегія маршрутизації",
      "RoutingStrategyDesc": "Установити загальну стратегію маршрутизації трафіку для вирішення всіх запитів.",
      "outboundTestUrl": "URL тесту outbound",
      "outboundTestUrlDesc": "URL для перевірки з'єднання outbound",
      "Torrent": "Блокувати протокол BitTorrent",
      "Inbounds": "Вхідні",
      "InboundsDesc": "Прийняття певних клієнтів.",
      "Outbounds": "Вихідні",
      "Balancers": "Балансери",
      "balancerTagRequired": "Тег обов'язковий",
      "balancerSelectorRequired": "Виберіть принаймні один вихідний",
      "OutboundsDesc": "Встановити шлях вихідного трафіку.",
      "Routings": "Правила маршрутизації",
      "RoutingsDesc": "Пріоритет кожного правила важливий!",
      "completeTemplate": "Усі",
      "logLevel": "Рівень журналу",
      "logLevelDesc": "Рівень журналу для журналів помилок із зазначенням інформації, яку потрібно записати.",
      "accessLog": "Журнал доступу",
      "accessLogDesc": "Шлях до файлу журналу доступу. Спеціальне значення 'none' вимикає журнали доступу",
      "errorLog": "Журнал помилок",
      "errorLogDesc": "Шлях до файлу журналу помилок. Спеціальне значення 'none' вимикає журнали помилок",
      "dnsLog": "Журнал DNS",
      "dnsLogDesc": "Чи включити журнали запитів DNS",
      "maskAddress": "Маскувати Адресу",
      "maskAddressDesc": "Маска IP-адреси, при активації автоматично замінює IP-адресу, яка з'являється у журналі.",
      "statistics": "Статистика",
      "statsInboundUplink": "Статистика вхідного аплінку",
      "statsInboundUplinkDesc": "Увімкнення збору статистики для вхідного трафіку всіх вхідних проксі.",
      "statsInboundDownlink": "Статистика вхідного даунлінку",
      "statsInboundDownlinkDesc": "Увімкнення збору статистики для вихідного трафіку всіх вхідних проксі.",
      "statsOutboundUplink": "Статистика вихідного аплінку",
      "statsOutboundUplinkDesc": "Увімкнення збору статистики для вхідного трафіку всіх вихідних проксі.",
      "statsOutboundDownlink": "Статистика вихідного даунлінку",
      "statsOutboundDownlinkDesc": "Увімкнення збору статистики для вихідного трафіку всіх вихідних проксі.",
      "rules": {
        "first": "Перший",
        "last": "Останній",
        "up": "Вгору",
        "down": "Вниз",
        "source": "Джерело",
        "dest": "Пункт призначення",
        "inbound": "Вхідний",
        "outbound": "Вихідний",
        "balancer": "Балансувальник",
        "info": "Інфо",
        "add": "Додати правило",
        "edit": "Редагувати правило",
        "useComma": "Елементи, розділені комами"
      },
      "routing": {
        "dragToReorder": "Перетягніть для зміни порядку"
      },
      "ruleForm": {
        "sourceIps": "IP джерела",
        "sourcePort": "Порт джерела",
        "vlessRoute": "VLESS route",
        "attributes": "Атрибути",
        "value": "Значення",
        "user": "Користувач",
        "inboundTags": "Теги вхідних",
        "outboundTag": "Тег вихідного",
        "balancerTag": "Тег балансувальника",
        "balancerTagTooltip": "Спрямовує трафік через один з налаштованих балансувальників навантаження"
      },
      "outboundForm": {
        "tagDuplicate": "Тег уже використовується іншим вихідним",
        "tagRequired": "Тег обов'язковий",
        "tagPlaceholder": "унікальний-тег",
        "localIpPlaceholder": "локальний IP",
        "addressRequired": "Адреса обов'язкова",
        "portRequired": "Порт обов'язковий",
        "optional": "опційно",
        "udpOverTcp": "UDP over TCP",
        "uotVersion": "Версія UoT",
        "inboundTag": "Тег вхідного",
        "inboundTagPlaceholder": "тег вхідного у правилах маршрутизації",
        "responseType": "Тип відповіді",
        "rewriteNetwork": "Переписати мережу",
        "unchanged": "(без змін)",
        "unchangedAddress": "(без змін) напр. 1.1.1.1",
        "rules": "Правила",
        "ruleN": "Правило {n}",
        "action": "Дія",
        "redirect": "Redirect",
        "fragment": "Fragment",
        "finalRules": "Фінальні правила",
        "overrideXrayPrivateIp": "Перевизначити дефолтний блок приватних IP у Xray",
        "blockDelay": "Затримка блоку (мс)",
        "reverseSniffing": "Зворотний sniffing",
        "workers": "Воркери",
        "reserved": "Зарезервовано",
        "minUploadInterval": "Мін. інтервал завантаження (мс)",
        "maxUploadSizeBytes": "Макс. розмір завантаження (байт)",
        "uplinkChunkSize": "Розмір chunk Uplink",
        "noGrpcHeader": "Без gRPC-заголовка",
        "maxConcurrency": "Макс. паралельність",
        "maxConnections": "Макс. з'єднань",
        "maxReuseTimes": "Макс. повторних використань",
        "maxRequestTimes": "Макс. запитів",
        "maxReusableSecs": "Макс. секунд повторного використання",
        "keepAlivePeriod": "Період keep alive",
        "authPassword": "Пароль авторизації",
        "visionTestpre": "Vision testpre",
        "serverNamePlaceholder": "ім'я сервера",
        "verifyPeerName": "Перевіряти ім'я peer",
        "pinnedSha256": "Pinned SHA256",
        "shortId": "Short ID",
        "sockopts": "Sockopts",
        "keepAliveInterval": "Інтервал keep alive",
        "markFwmark": "Mark (fwmark)",
        "interface": "Інтерфейс",
        "ipv6Only": "Лише IPv6",
        "acceptProxyProtocol": "Приймати proxy protocol",
        "tcpUserTimeoutMs": "TCP user timeout (мс)",
        "tcpKeepAliveIdleS": "TCP keep-alive idle (с)"
      },
      "outbound": {
        "addOutbound": "Додати вихідний",
        "addReverse": "Додати реверс",
        "editOutbound": "Редагувати вихідні",
        "editReverse": "Редагувати реверс",
        "reverseTag": "Тег реверс-проксі",
        "reverseTagDesc": "Тег вихідного з'єднання для простого реверс-проксі VLESS. Залиште порожнім для вимкнення.",
        "reverseTagPlaceholder": "тег вихідного (порожнє = вимкнено)",
        "tag": "Тег",
        "tagDesc": "Унікальний тег",
        "address": "Адреса",
        "reverse": "Зворотний",
        "domain": "Домен",
        "type": "Тип",
        "bridge": "Bridge",
        "portal": "Portal",
        "link": "Посилання",
        "intercon": "Взаємозв'язок",
        "settings": "Налаштування",
        "accountInfo": "Інформація про обліковий запис",
        "outboundStatus": "Статус виходу",
        "sendThrough": "Надіслати через",
        "test": "Тест",
        "testResult": "Результат тесту",
        "testing": "Тестування з'єднання...",
        "testSuccess": "Тест успішний",
        "testFailed": "Тест не пройдено",
        "testError": "Не вдалося протестувати вихідне з'єднання",
        "testModeTooltip": "TCP: швидкий dial-only probe. HTTP: повний запит через xray.",
        "testAll": "Тестувати всі",
        "nordvpn": "NordVPN",
        "accessToken": "Токен доступу",
        "country": "Країна",
        "server": "Сервер",
        "city": "Місто",
        "allCities": "Усі міста",
        "privateKey": "Приватний ключ",
        "load": "Навантаження"
      },
      "balancer": {
        "addBalancer": "Додати балансир",
        "editBalancer": "Редагувати балансир",
        "balancerStrategy": "Стратегія",
        "balancerSelectors": "Селектори",
        "tag": "Тег",
        "tagDesc": "Унікальний тег",
        "tagDuplicate": "Тег уже використовується іншим балансувальником",
        "tagPlaceholder": "унікальний тег балансувальника",
        "selector": "Селектор",
        "fallback": "Fallback",
        "expected": "Очікуване",
        "expectedPlaceholder": "оптимальна кількість вузлів",
        "maxRtt": "Макс. RTT",
        "tolerance": "Допуск",
        "baselines": "Baselines",
        "costs": "Costs",
        "balancerDesc": "Неможливо використовувати balancerTag і outboundTag одночасно. Якщо використовувати одночасно, працюватиме лише outboundTag."
      },
      "wireguard": {
        "secretKey": "Приватний ключ",
        "publicKey": "Публічний ключ",
        "allowedIPs": "Дозволені IP-адреси",
        "endpoint": "Кінцева точка",
        "psk": "Спільний ключ",
        "domainStrategy": "Стратегія домену"
      },
      "tun": {
        "nameDesc": "Назва інтерфейсу TUN. Значення за замовчуванням - 'xray0'",
        "mtuDesc": "Максимальна одиниця передачі. Максимальний розмір пакетів даних. Значення за замовчуванням - 1500",
        "userLevel": "Рівень користувача",
        "userLevelDesc": "Всі з'єднання, встановлені через цей вхід, використовуватимуть цей рівень користувача. Значення за замовчуванням - 0"
      },
      "nord": {
        "accessToken": "Access token",
        "privateKey": "Приватний ключ",
        "noServers": "Серверів для обраної країни не знайдено",
        "noPublicKey": "Обраний сервер не повідомляє публічного ключа NordLynx.",
        "outboundAdded": "Вихідний NordVPN додано",
        "outboundUpdated": "Вихідний NordVPN оновлено"
      },
      "warp": {
        "licenseError": "Не вдалося встановити ліцензію WARP.",
        "fetchFirst": "Спочатку отримайте WARP-конфіг.",
        "createAccount": "Створити акаунт WARP",
        "accessToken": "Access token",
        "deviceId": "ID пристрою",
        "licenseKey": "Ключ ліцензії",
        "privateKey": "Приватний ключ",
        "deleteAccount": "Видалити акаунт",
        "settings": "Налаштування",
        "licenseKeyLabel": "Ключ ліцензії WARP / WARP+",
        "key": "Ключ",
        "keyPlaceholder": "26-символьний ключ WARP+",
        "accountInfo": "Інформація про акаунт",
        "deviceName": "Назва пристрою",
        "deviceModel": "Модель пристрою",
        "deviceEnabled": "Пристрій увімкнено",
        "accountType": "Тип акаунта",
        "role": "Роль",
        "warpPlusData": "WARP+ data",
        "quota": "Квота",
        "usage": "Використання",
        "addOutbound": "Додати вихідний"
      },
      "dns": {
        "enable": "Увімкнути DNS",
        "enableDesc": "Увімкнути вбудований DNS-сервер",
        "tag": "Мітка вхідного DNS",
        "tagDesc": "Ця мітка буде доступна як вхідна мітка в правилах маршрутизації.",
        "clientIp": "IP клієнта",
        "clientIpDesc": "Використовується для повідомлення серверу про вказане місцезнаходження IP під час DNS-запитів",
        "disableCache": "Вимкнути кеш",
        "disableCacheDesc": "Вимкнути кешування DNS",
        "disableFallback": "Вимкнути резервний DNS",
        "disableFallbackDesc": "Вимкнути резервні DNS-запити",
        "disableFallbackIfMatch": "Вимкнути резервний DNS при збігу",
        "disableFallbackIfMatchDesc": "Вимкнути резервні DNS-запити при збігу списку доменів DNS-сервера",
        "enableParallelQuery": "Увімкнути паралельні запити",
        "enableParallelQueryDesc": "Увімкнути паралельні DNS-запити до кількох серверів для швидшого вирішення",
        "strategy": "Стратегія запиту",
        "strategyDesc": "Загальна стратегія вирішення доменних імен",
        "add": "Додати сервер",
        "edit": "Редагувати сервер",
        "domains": "Домени",
        "expectIPs": "Очікувані IP",
        "unexpectIPs": "Неочікувані IP",
        "useSystemHosts": "Використовувати системні Hosts",
        "useSystemHostsDesc": "Використовувати файл hosts з встановленої системи",
        "serveStale": "Видавати застарілі",
        "serveStaleDesc": "Повертати застарілі результати з кешу під час фонового оновлення",
        "serveExpiredTTL": "TTL застарілих",
        "serveExpiredTTLDesc": "Термін дії (секунди) застарілих записів кешу; 0 = ніколи",
        "timeoutMs": "Тайм-аут (мс)",
        "skipFallback": "Пропустити Fallback",
        "finalQuery": "Фінальний запит",
        "hosts": "Hosts",
        "hostsAdd": "Додати Host",
        "hostsEmpty": "Host не визначено",
        "hostsDomain": "Домен (напр. domain:example.com)",
        "hostsValues": "IP або домен — введіть і натисніть Enter",
        "usePreset": "Використати шаблон",
        "dnsPresetTitle": "Шаблони DNS",
        "dnsPresetFamily": "Сімейний",
        "clearAll": "Видалити всі",
        "clearAllTitle": "Видалити всі DNS-сервери?",
        "clearAllConfirm": "Усі DNS-сервери буде видалено зі списку. Дію не можна скасувати."
      },
      "fakedns": {
        "add": "Додати підроблений DNS",
        "edit": "Редагувати підроблений DNS",
        "ipPool": "Підмережа IP-пулу",
        "poolSize": "Розмір пулу"
      }
    }
  },
  "tgbot": {
    "keyboardClosed": "❌ Клавіатуру закрито!",
    "noResult": "❗ Немає результату!",
    "noQuery": "❌ Запит не знайдено! Будь ласка, використовуйте команду ще раз!",
    "wentWrong": "❌ Щось пішло не так!",
    "noIpRecord": "❗ Немає запису IP!",
    "noInbounds": "❗ Вхідні не знайдені!",
    "unlimited": "♾ Необмежено (Скинути)",
    "add": "Додати",
    "month": "Місяць",
    "months": "Місяці",
    "day": "День",
    "days": "Дні",
    "hours": "Години",
    "minutes": "Хвилини",
    "unknown": "Невідомо",
    "inbounds": "Вхідні",
    "clients": "Клієнти",
    "offline": "🔴 Не в мережі",
    "online": "🟢 У мережі",
    "commands": {
      "unknown": "❗ Невідома команда.",
      "pleaseChoose": "👇 Будь ласка, виберіть:\r\n",
      "help": "🤖 Ласкаво просимо до цього бота! Він розроблений, щоб надавати певні дані з веб-панелі та дозволяє вносити зміни за потреби.\r\n\r\n",
      "start": "👋 Привіт <i>{{ .Firstname }}</i>.\r\n",
      "welcome": "🤖 Ласкаво просимо до <b>{{ .Hostname }}</b> бота керування.\r\n",
      "status": "✅ Бот в порядку!",
      "usage": "❗ Введіть текст для пошуку!",
      "getID": "🆔 Ваш ідентифікатор: <code>{{ .ID }}</code>",
      "helpAdminCommands": "Для перезапуску Xray Core:\r\n<code>/restart</code>\r\n\r\nДля пошуку електронної пошти клієнта:\r\n<code>/usage [Електронна пошта]</code>\r\n\r\nДля пошуку вхідних (зі статистикою клієнта):\r\n<code>/inbound [Примітка]</code>\r\n\r\nID чату Telegram:\r\n<code>/id</code>",
      "helpClientCommands": "Для пошуку статистики використовуйте наступну команду:\r\n<code>/usage [Електронна пошта]</code>\r\n\r\nID чату Telegram:\r\n<code>/id</code>",
      "restartUsage": "\r\n\r\n<code>/restart</code>",
      "restartSuccess": "✅ Операція успішна!",
      "restartFailed": "❗ Помилка в операції.\r\n\r\n<code>Помилка: {{ .Error }}</code>.",
      "xrayNotRunning": "❗ Xray Core не запущений.",
      "startDesc": "Показати головне меню",
      "helpDesc": "Довідка по боту",
      "statusDesc": "Перевірити статус бота",
      "idDesc": "Показати ваш Telegram ID"
    },
    "messages": {
      "cpuThreshold": "🔴 Навантаження ЦП  {{ .Percent }}% перевищує порогове значення {{ .Threshold }}%",
      "selectUserFailed": "❌ Помилка під час вибору користувача!",
      "userSaved": "✅ Користувача Telegram збережено.",
      "loginSuccess": "✅ Успішно ввійшли в панель\r\n",
      "loginFailed": "❗️ Помилка входу в панель.\r\n",
      "2faFailed": "Помилка 2FA",
      "report": "🕰 Заплановані звіти: {{ .RunTime }}\r\n",
      "datetime": "⏰ Дата й час: {{ .DateTime }}\r\n",
      "hostname": "💻 Хост: {{ .Hostname }}\r\n",
      "version": "🚀 3X-UI Версія: {{ .Version }}\r\n",
      "xrayVersion": "📡 Xray Версія: {{ .XrayVersion }}\r\n",
      "ipv6": "🌐 IPv6: {{ .IPv6 }}\r\n",
      "ipv4": "🌐 IPv4: {{ .IPv4 }}\r\n",
      "ip": "🌐 IP: {{ .IP }}\r\n",
      "ips": "🔢 IP:\r\n{{ .IPs }}\r\n",
      "serverUpTime": "⏳ Час роботи: {{ .UpTime }} {{ .Unit }}\r\n",
      "serverLoad": "📈 Завантаження системи: {{ .Load1 }}, {{ .Load2 }}, {{ .Load3 }}\r\n",
      "serverMemory": "📋 RAM: {{ .Current }}/{{ .Total }}\r\n",
      "tcpCount": "🔹 TCP: {{ .Count }}\r\n",
      "udpCount": "🔸 UDP: {{ .Count }}\r\n",
      "traffic": "🚦 Трафік: {{ .Total }} (↑{{ .Upload }},↓{{ .Download }})\r\n",
      "xrayStatus": "ℹ️ Статус: {{ .State }}\r\n",
      "username": "👤 Ім'я користувача: {{ .Username }}\r\n",
      "reason": "❗️ Причина: {{ .Reason }}\r\n",
      "time": "⏰ Час: {{ .Time }}\r\n",
      "inbound": "📍 Вхідний: {{ .Remark }}\r\n",
      "port": "🔌 Порт: {{ .Port }}\r\n",
      "expire": "📅 Дата закінчення: {{ .Time }}\r\n",
      "expireIn": "📅 Термін дії: {{ .Time }}\r\n",
      "active": "💡 Активний: {{ .Enable }}\r\n",
      "enabled": "🚨 Увімкнено: {{ .Enable }}\r\n",
      "online": "🌐 Стан підключення: {{ .Status }}\r\n",
      "lastOnline": "🔙 Був(ла) онлайн: {{ .Time }}\r\n",
      "email": "📧 Email: {{ .Email }}\r\n",
      "upload": "🔼 Завантаження: ↑{{ .Upload }}\r\n",
      "download": "🔽 Завантаження: ↓{{ .Download }}\r\n",
      "total": "📊 Усього: ↑↓{{ .UpDown }} / {{ .Total }}\r\n",
      "TGUser": "👤 Користувач Telegram: {{ .TelegramID }}\r\n",
      "exhaustedMsg": "🚨 Вичерпано {{ .Type }}:\r\n",
      "exhaustedCount": "🚨 Вичерпано кількість {{ .Type }} count:\r\n",
      "onlinesCount": "🌐 Онлайн-клієнти: {{ .Count }}\r\n",
      "disabled": "🛑 Вимкнено: {{ .Disabled }}\r\n",
      "depleteSoon": "🔜 Скоро вичерпається: {{ .Deplete }}\r\n\r\n",
      "backupTime": "🗄 Час резервного копіювання: {{ .Time }}\r\n",
      "refreshedOn": "\r\n📋🔄 Оновлено: {{ .Time }}\r\n\r\n",
      "yes": "✅ Так",
      "no": "❌ Ні",
      "received_id": "🔑📥 ID оновлено.",
      "received_password": "🔑📥 Пароль оновлено.",
      "received_email": "📧📥 Електронна пошта оновлена.",
      "received_comment": "💬📥 Коментар оновлено.",
      "id_prompt": "🔑 Стандартний ID: {{ .ClientId }}\n\nВведіть ваш ID.",
      "pass_prompt": "🔑 Стандартний пароль: {{ .ClientPassword }}\n\nВведіть ваш пароль.",
      "email_prompt": "📧 Стандартний email: {{ .ClientEmail }}\n\nВведіть ваш email.",
      "comment_prompt": "💬 Стандартний коментар: {{ .ClientComment }}\n\nВведіть ваш коментар.",
      "inbound_client_data_id": "🔄 Вхід: {{ .InboundRemark }}\n\n🔑 ID: {{ .ClientId }}\n📧 Електронна пошта: {{ .ClientEmail }}\n📊 Трафік: {{ .ClientTraffic }}\n📅 Дата завершення: {{ .ClientExp }}\n🌐 Обмеження IP: {{ .IpLimit }}\n💬 Коментар: {{ .ClientComment }}\n\nТепер ви можете додати клієнта до вхідного з'єднання!",
      "inbound_client_data_pass": "🔄 Вхід: {{ .InboundRemark }}\n\n🔑 Пароль: {{ .ClientPass }}\n📧 Електронна пошта: {{ .ClientEmail }}\n📊 Трафік: {{ .ClientTraffic }}\n📅 Дата завершення: {{ .ClientExp }}\n🌐 Обмеження IP: {{ .IpLimit }}\n💬 Коментар: {{ .ClientComment }}\n\nТепер ви можете додати клієнта до вхідного з'єднання!",
      "cancel": "❌ Процес скасовано! \n\nВи можете знову розпочати, використовуючи /start у будь-який час. 🔄",
      "error_add_client": "⚠️ Помилка:\n\n {{ .error }}",
      "using_default_value": "Гаразд, залишу значення за замовчуванням. 😊",
      "incorrect_input": "Ваш ввід невірний.\nФрази повинні бути без пробілів.\nПравильний приклад: aaaaaa\nНеправильний приклад: aaa aaa 🚫",
      "AreYouSure": "Ви впевнені? 🤔",
      "SuccessResetTraffic": "📧 Електронна пошта: {{ .ClientEmail }}\n🏁 Результат: ✅ Успішно",
      "FailedResetTraffic": "📧 Електронна пошта: {{ .ClientEmail }}\n🏁 Результат: ❌ Невдача \n\n🛠️ Помилка: [ {{ .ErrorMessage }} ]",
      "FinishProcess": "🔚 Процес скидання трафіку завершено для всіх клієнтів."
    },
    "buttons": {
      "closeKeyboard": "❌ Закрити клавіатуру",
      "cancel": "❌ Скасувати",
      "cancelReset": "❌ Скасувати скидання",
      "cancelIpLimit": "❌ Скасувати обмеження IP",
      "confirmResetTraffic": "✅ Підтвердити скидання трафіку?",
      "confirmClearIps": "✅ Підтвердити очищення IP-адрес?",
      "confirmRemoveTGUser": "✅ Підтвердити видалення користувача Telegram?",
      "confirmToggle": "✅ Підтвердити ввімкнути/вимкнути користувача?",
      "dbBackup": "Отримати резервну копію БД",
      "serverUsage": "Використання сервера",
      "getInbounds": "Отримати вхідні",
      "depleteSoon": "Скоро вичерпати",
      "clientUsage": "Отримати використання",
      "onlines": "Онлайн-клієнти",
      "commands": "Команди",
      "refresh": "🔄 Оновити",
      "clearIPs": "❌ Очистити IP-адреси",
      "removeTGUser": "❌ Видалити користувача Telegram",
      "selectTGUser": "👤 Виберіть користувача Telegram",
      "selectOneTGUser": "👤 Виберіть користувача Telegram:",
      "resetTraffic": "📈 Скинути трафік",
      "resetExpire": "📅 Змінити термін дії",
      "ipLog": "🔢 IP журнал",
      "ipLimit": "🔢 IP Ліміт",
      "setTGUser": "👤 Встановити користувача Telegram",
      "toggle": "🔘 Увімкнути / Вимкнути",
      "custom": "🔢 Своє",
      "confirmNumber": "✅ Підтвердити: {{ .Num }}",
      "confirmNumberAdd": "✅ Підтвердити додавання: {{ .Num }}",
      "limitTraffic": "🚧 Ліміт трафіку",
      "getBanLogs": "Отримати журнали заборон",
      "allClients": "Всі Клієнти",
      "addClient": "Додати клієнта",
      "submitDisable": "Надіслати як вимкнено ☑️",
      "submitEnable": "Надіслати як увімкнено ✅",
      "use_default": "🏷️ Використати типове",
      "change_id": "⚙️🔑 ID",
      "change_password": "⚙️🔑 Пароль",
      "change_email": "⚙️📧 Email",
      "change_comment": "⚙️💬 Коментар",
      "change_flow": "⚙️🚦 Flow",
      "ResetAllTraffics": "Скинути весь трафік",
      "SortedTrafficUsageReport": "Відсортований звіт про використання трафіку"
    },
    "answers": {
      "successfulOperation": "✅ Операція успішна!",
      "errorOperation": "❗ Помилка в роботі.",
      "getInboundsFailed": "❌ Не вдалося отримати вхідні повідомлення.",
      "getClientsFailed": "❌ Не вдалося отримати клієнтів.",
      "canceled": "❌ {{ .Email }}: Операцію скасовано.",
      "clientRefreshSuccess": "✅ {{ .Email }}: Клієнт успішно оновлено.",
      "IpRefreshSuccess": "✅ {{ .Email }}: IP-адреси успішно оновлено.",
      "TGIdRefreshSuccess": "✅ {{ .Email }}: Користувач Telegram клієнта успішно оновлено.",
      "resetTrafficSuccess": "✅ {{ .Email }}: Трафік скинуто успішно.",
      "setTrafficLimitSuccess": "✅ {{ .Email }}: Ліміт трафіку успішно збережено.",
      "expireResetSuccess": "✅ {{ .Email }}: Успішно скинуто дні закінчення терміну дії.",
      "resetIpSuccess": "✅ {{ .Email }}: IP обмеження {{ .Count }} успішно збережено.",
      "clearIpSuccess": "✅ {{ .Email }}: IP успішно очищено.",
      "getIpLog": "✅ {{ .Email }}: Отримати IP-журнал.",
      "getUserInfo": "✅ {{ .Email }}: Отримати інформацію про користувача Telegram.",
      "removedTGUserSuccess": "✅ {{ .Email }}: Користувача Telegram видалено успішно.",
      "enableSuccess": "✅ {{ .Email }}: Увімкнути успішно.",
      "disableSuccess": "✅ {{ .Email }}: Успішно вимкнено.",
      "askToAddUserId": "Вашу конфігурацію не знайдено!\r\nБудь ласка, попросіть свого адміністратора використовувати ваш ідентифікатор Telegram у вашій конфігурації.\r\n\r\nВаш ідентифікатор користувача: <code>{{ .TgUserID }}</code>",
      "chooseClient": "Виберіть клієнта для Вхідного {{ .Inbound }}",
      "chooseInbound": "Виберіть Вхідний"
    }
  }
}
